module.exports = __webpack_public_path__ + "img/symbol_12.fa47e5b7.png";